"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiTableCell: {
    head: {
      "&:first-of-type": {
        borderRadius: "4px 0 0 0"
      },
      "&:last-of-type": {
        borderRadius: "0 4px 0 0",
        borderRight: "none"
      },
      borderRight: "1px solid ".concat(_theme.palette.brand.grey.pebble),
      fontWeight: "bold",
      lineHeight: 1,
      whiteSpace: "nowrap"
    },
    root: {
      borderBottom: "1px solid ".concat(_theme.palette.brand.grey.pebble),
      fontSize: "0.75rem",
      maxWidth: "18rem",
      padding: "".concat(_theme.spacing[2], " ").concat(_theme.spacing[3])
    },
    stickyHeader: {
      backgroundColor: _theme.palette.brand.grey.lightGrey
    }
  },
  MuiTableContainer: {
    root: {
      borderCollapse: "separate",
      borderColor: _theme.palette.brand.grey.pebble,
      borderRadius: "4px 4px 0 0",
      borderStyle: "solid",
      borderWidth: "1px",
      maxHeight: "32rem",
      overflowX: "auto"
    }
  },
  MuiTableHead: {
    root: {
      background: _theme.palette.brand.grey.lightGrey
    }
  },
  MuiTableRow: {
    root: {
      "& [class*=fa-chevron-right]": {
        visibility: "collapse"
      },
      "&.MuiTableRow-head:hover": {
        background: _theme.palette.brand.grey.lightGrey
      },
      "&:hover": {
        "& [class*=fa-chevron-right]": {
          visibility: "visible"
        },
        background: _theme.palette.primary.light
      }
    }
  },
  MuiTableSortLabel: {
    icon: {
      color: "".concat(_theme.palette.primary.main, " !important")
    },
    root: {
      "&:hover, &:focus": {
        color: "inherit",
        textDecoration: "underline"
      }
    }
  }
};
exports.default = _default;